import React, { useCallback, useState } from "react";
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";
import { useNavigate } from 'react-router-dom';

const ResearchProjectsPage = () => {
    const {
        researchProjects,
        researchProjectsKeys,
        addResearchProject,
        editResearchProject,
        deleteResearchProject,
    } = useFirebase();

    const { user } = useAuthentication();
    const navigate = useNavigate();
    
    const [editProjectIndex, setEditProjectIndex] = useState(null);
    const [newProject, setNewProject] = useState('');
    const [editingValue, setEditingValue] = useState('');
    const [currentKey, setCurrentKey] = useState('');

    const handleEnquiryButtonClicked = useCallback(() => {
        navigate('/contacts');
    }, [navigate]);

    const handleAddProject = (key) => {
        if (newProject.trim()) {
            addResearchProject(key, newProject).then(() => {
                setNewProject('');
                setCurrentKey('');
                window.location.reload(); // Reload after adding a project
            });
        }
    };

    const handleEditProject = (key, index, currentValue) => {
        setCurrentKey(key); // Set the current key
        setEditProjectIndex(index);
        setEditingValue(currentValue);
    };

    const handleSaveEdit = () => {
        if (editingValue.trim()) {
            editResearchProject(currentKey, editProjectIndex, editingValue).then(() => {
                setEditProjectIndex(null);
                setEditingValue('');
                setCurrentKey(''); // Clear the current key
                window.location.reload(); // Reload after editing a project
            });
        }
    };

    const handleDeleteProject = (key, index) => {
        console.log(`Attempting to delete project at index ${index} in ${key}`);
        
        deleteResearchProject(key, index).then(() => {
            console.log(`Deleted project at index ${index} in ${key}`);
            window.location.reload(); // Reload after deleting a project
        }).catch(error => {
            console.error("Error deleting project:", error);
        });
    };

    return (
        <div className="research-projects-page-container">
            <div className="research-projects-heading">Research Projects</div>
            {researchProjects ? (
                <div>
                    <div className="research-projects-content">
                        {researchProjectsKeys.map((key, index) => {
                            const items = researchProjects[key];

                            if (Array.isArray(items) && items.length > 0) {
                                return (
                                    <div key={index}>
                                        <h1 className="research-projects-type">
                                            {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                                            {user && (
                                                <span>
                                                    <input
                                                        type="text"
                                                        value={currentKey === key ? newProject : ''}
                                                        onChange={(e) => {
                                                            setCurrentKey(key);
                                                            setNewProject(e.target.value);
                                                        }}
                                                        placeholder="New Project"
                                                    />
                                                    <button onClick={() => handleAddProject(key)}>Add Project</button>
                                                </span>
                                            )}
                                        </h1>
                                        <ul>
                                            {items.map((item, idx) => (
                                                <li className="research-projects-papers" key={idx}>
                                                    {editProjectIndex === idx && currentKey === key ? (
                                                        <div>
                                                            <input
                                                                value={editingValue}
                                                                onChange={(e) => setEditingValue(e.target.value)}
                                                            />
                                                            <button onClick={handleSaveEdit}>Save</button>
                                                            <button onClick={() => {
                                                                setEditProjectIndex(null);
                                                                setEditingValue('');
                                                                setCurrentKey(''); // Clear the current key
                                                            }}>Cancel</button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="content">{idx + 1}. {item}</div>
                                                            {user && (
                                                                <>
                                                                    <button onClick={() => handleEditProject(key, idx, item)}>Edit</button>
                                                                    <button onClick={() => handleDeleteProject(key, idx)}>Delete</button>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                );
                            }
                            return null;
                        })}
                        <div className="project-enquiry">
                            <button className="research-projects-button" onClick={handleEnquiryButtonClicked}>
                                For Project Enquiries
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}

            <div className="research-projects-copyright">
                &copy; All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
            </div>
        </div>
    );
};

export default ResearchProjectsPage;